import { useState } from 'react';
import { useAuthState } from '../hooks/useAuthState';
import { addGroupMember } from '../lib/firestore/groups';
import { canSponsorMember } from '../lib/permissions';
import '../styles/SponsorMember.css';

const SponsorMember = ({ groupId, onSponsored }) => {
  const { user } = useAuthState();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [checkingEligibility, setCheckingEligibility] = useState(false);
  const [canSponsor, setCanSponsor] = useState(null);

  const checkEligibility = async () => {
    if (!user || !phoneNumber.trim()) return;

    setCheckingEligibility(true);
    setError('');

    try {
      const eligibility = await canSponsorMember(groupId, user.uid);
      setCanSponsor(eligibility);
      
      if (!eligibility.can) {
        setError(eligibility.reason || 'Cannot sponsor member');
      }
    } catch (err) {
      setError(err.message || 'Failed to check eligibility');
    } finally {
      setCheckingEligibility(false);
    }
  };

  const handleSponsor = async (e) => {
    e.preventDefault();
    if (!user || !phoneNumber.trim()) return;

    setLoading(true);
    setError('');

    try {
      // For now, we'll create a pending member entry
      // In production, this would send an invite with sponsor metadata
      const phoneDigits = phoneNumber.replace(/\D/g, '');
      
      // Check if we can sponsor first
      const eligibility = await canSponsorMember(groupId, user.uid);
      if (!eligibility.can) {
        setError(eligibility.reason || 'Cannot sponsor this member');
        setLoading(false);
        return;
      }

      // Note: In full implementation, this would create an invite with sponsor metadata
      // For now, we'll just show success message
      setError('');
      alert(`Sponsorship invitation will be sent to ${phoneNumber}. They'll need to accept to join the group.`);
      
      if (onSponsored) {
        onSponsored();
      }

      setPhoneNumber('');
    } catch (err) {
      setError(err.message || 'Failed to sponsor member');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sponsor-member-card">
      <h3>Sponsor a Member</h3>
      <p className="sponsor-description">
        Sponsor someone to join this group. They'll be added as a sponsored member.
      </p>

      <form onSubmit={handleSponsor} className="sponsor-form">
        <div className="form-group">
          <label htmlFor="phone">Phone Number (E.164 format)</label>
          <input
            type="tel"
            id="phone"
            className="input"
            placeholder="+15551234567"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="sponsor-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={checkEligibility}
            disabled={checkingEligibility || !phoneNumber.trim()}
          >
            {checkingEligibility ? 'Checking...' : 'Check Eligibility'}
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading || !phoneNumber.trim()}
          >
            {loading ? 'Sponsoring...' : 'Sponsor Member'}
          </button>
        </div>

        {canSponsor?.can && (
          <div className="eligibility-success">
            ✅ You are eligible to sponsor members
          </div>
        )}
      </form>
    </div>
  );
};

export default SponsorMember;




